export const environment: WindowEnv = {
  production: true,
  apiUrl: window?.env?.apiUrl || 'localhost',
  govUrl: window?.env?.govUrl || 'localhost',
  pilotUrl: window?.env?.pilotUrl || 'localhost',
  baseAssetUrl: window?.env?.baseAssetUrl || 'localhost',
  sentry: {
    dsn: window?.env?.sentry?.dsn || '',
    posthogIntegration: {
      organization: window?.env?.sentry?.posthogIntegration?.organization || '',
      projectId: window?.env?.sentry?.posthogIntegration?.projectId || 0,
      prefix: window?.env?.sentry?.posthogIntegration?.prefix || '',
    },
  },
  postHog: {
    apiKey: window?.env?.postHog?.apiKey || '',
    apiHost: window?.env?.postHog?.apiHost || '',
  },
  environment: window?.env?.environment,
  authProvider: window?.env?.authProvider || 'auth0',
  auth: {
    audience: window?.env?.auth?.audience || '',
    clientID: window?.env?.auth?.clientID || '',
    connection: window?.env?.auth?.connection || '',
    domain: window?.env?.auth?.domain || '',
    redirect: window?.env?.auth?.redirect || '',
    scope: window?.env?.auth?.scope || '',
  },
  keycloak: {
    url: window?.env?.keycloak?.url || '',
    realm: window?.env?.keycloak?.realm || '',
    clientID: window?.env?.keycloak?.clientID || '',
  },
};
